import { Route } from "react-router-dom";

import PageNotFound from "../pages/PageNowFound/PageNotFound";

export const pageNotFound = <Route path="*" element={<PageNotFound />} />;
